import {
  CALLING_MODES,
  InteractionType
} from 'src/pages/CaseDetails/feedbackForm/interfaces/index.type';

export interface CreateInteractionRequest {
  accountNumber: string;
  recipientName?: string;
  recipientPhoneNumber: string | number;
  callingMode: CALLING_MODES;
  interactionType: InteractionType;
  externalCallId?: string;
  sourceType?: string;
}

export interface AmeyoShowCrmEventData {
  phone: string;
  crtObjectId: string;
  loanaccountnumber: string;
}

export interface AmeyoButtonStates {
  acceptButton: boolean;
  rejectButton: boolean;
  disconnectButton: boolean;
}

export enum PhoneNumberSources {
  CIBIL_TRIGGER = 'CIBIL Trigger',
  PRIMARY = 'Primary',
  LONGHORN = 'Longhorn',
  BUREAU = 'Bureau',
  CREDIT_ANALYSIS = 'Credit Analysis',
  SPADE = 'Spade',
  ALGO_360 = 'Algo 360',
  KARZA = 'Karza',
  CUSTOMER_SUPPORT = 'Customer Support',
  CIBIL_SCRUB = 'CIBIL Scrub',
  SECONDARY = 'Secondary',
  CONTACT_BOOK = 'Contact Book',
  UNKNOWN = 'Unknown',
  MMI = 'MMI',
  AADHAAR = 'Aadhaar',
  CKYC = 'CKYC',
  EKYC = 'EKYC',
  ITD = 'ITD',
  DIGILOCKER = 'DigiLocker',
  CIBIL = 'CIBIL',
  AVS_V1 = 'AVS V1',
  CUSTOMER = 'Customer',
  FINORAMIC = 'Finoramic',
  BANK_STATEMENT = 'Bank Statement',
  GST = 'GST',
  CRIF = 'CRIF',
  CIBIL_CU = 'CIBIL CU',
  FIELD_APP = 'Field App',
  UDHAAR = 'Udhaar',
  SKIP_TRACING = 'Customer Outreach',
  DS_META_ADDRESS = 'DS Meta Address',
  UPI = 'UPI',
  DATA_SUTRAM = 'Data Sutram',
  ACCOUNT_AGGREGATOR = 'Bank Statement',
  HRC = 'HRC'
}

export enum PhoneNumberSourceText {
  'Cibil Trigger' = 'CIBIL Trigger',
  'Primary Contact' = 'Primary',
  'Collection Agent Feedback' = 'Longhorn',
  'Credit Bureau Scrub' = 'Bureau',
  'Credit Bureau Underwriting' = 'Credit Analysis',
  Spade = 'Spade',
  'SMS Data' = 'Algo 360',
  Karza = 'Karza',
  'Customer Support' = 'Customer Support',
  'Cibil Scrub' = 'CIBIL Scrub',
  'Secondary Contact' = 'Secondary',
  'Contact Book' = 'Contact Book',
  'Unknown' = 'Unknown',
  'Map My India' = 'MMI',
  Aadhaar = 'Aadhaar',
  CKYC = 'CKYC',
  EKYC = 'EKYC',
  ITD = 'ITD',
  DIGILOCKER = 'DigiLocker',
  Cibil = 'CIBIL',
  'Address Verification V1 Longhorn' = 'AVS V1',
  'Customer Entered Info' = 'Customer',
  'Finoramic Gmail vendor' = 'Finoramic',
  'Bank Statement' = 'Bank Statement',
  GST = 'GST',
  CRIF = 'CRIF',
  'Cibil from Under Writing' = 'CIBIL CU',
  'Field App' = 'Field App',
  Udhaar = 'Udhaar',
  'Skip Tracing' = 'Customer Outreach',
  'Customer Outreach' = 'Customer Outreach',
  'Meta Address' = 'DS Meta Address',
  'GPT Meta Address' = 'GPT Meta Address',
  UPI = 'UPI',
  'Data Sutram' = 'Data Sutram',
  'HRC contacted spade' = 'HRC',
  'HRC' = 'HRC',
  'Account Aggregator' = 'Account Aggregator',
  "User's GL" = "User's GL",
  'Experian' = 'Experian'
}

export interface onToggleAmeyoStatusDataProps {
  ameyoTogglePrevStatus: 'OFF' | 'ON';
  ameyoToggleNewStatus: 'OFF' | 'ON';
}

export interface IConnectedCustomer {
  lan: string;
  phoneNumber: string;
  customerId: string;
  customerName: string;
  businessVertical: string;
  caseReferenceId: string;
}

export interface GetAgentCallAttemptedCountRequestParams {
  includeCallBridgeCount?: boolean;
  includeAmeyoCallCount?: boolean;
}
